import { Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICoordinateSystem } from '@app/api/interfaces/coordinate-system.interface';
import { ICustomCoordinates } from '@app/api/interfaces/common/custom-coordinates';
import { MockService } from '@mock/mock.service';
import { coordinateSystemForProject, coordinateSystemsMockData } from '@mock/data/coordinate-systems-mock.data';

@Injectable({ providedIn: 'root' })
export class CoordinateSystemsMockService extends MockService {
  public readonly coordinateSystems: ICoordinateSystem[] = coordinateSystemsMockData;

  public getAll(): Observable<IApiResponse<ICoordinateSystem[], object>> {
    return this.mockResponse('COORDINATE_SYSTEMS:getAll', {
      data: this.coordinateSystems,
      meta: {},
    }).pipe(delay(this.requestDelay));
  }

  /**
   * A coordinate pair in the system of its project, with a magnitude that fits that system's unit —
   * a projected grid gets grid-scale values, a geographic one degrees. Deterministic in `index` so
   * a reload keeps rendering the same pairs.
   */
  public generateCustomCoordinates(projectId: string, index: number): ICustomCoordinates {
    const system = coordinateSystemForProject(projectId);
    const isDegrees = system.axis1Unit === '°';

    return {
      coordinateSystemId: system.id,
      axis1: isDegrees ? -180 + ((index * 13) % 360) : 530000 + index * 13,
      axis2: isDegrees ? -90 + ((index * 17) % 180) : 180000 + index * 17,
    };
  }
}
